import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { BaseResponse } from '@services/api/api-base.service'
import { ManagementApiBaseService } from '@services/api/management-api-base.service'
import {
	NoticeSessionRepresentation,
	NoticeSessionRepresentationMessageRequest,
	NoticeSessionRepresentationStatus
} from '@models/planning/notice-session-representation.model'
import { Retry } from '@services/decorators/retry.decorator'

@Injectable({
	providedIn: 'root'
})
export class NoticeSessionRepresentationService extends ManagementApiBaseService<any> {
	private readonly source: string

	constructor(override http: HttpClient) {
		super(http)
		this.source = 'notice-session-representations'
	}

	save(entity: NoticeSessionRepresentation) {
		return this.post<NoticeSessionRepresentation, BaseResponse>(`${this.source}`, entity)
	}

	update(id: string, entity: NoticeSessionRepresentation) {
		return this.put<NoticeSessionRepresentation, BaseResponse>(`${this.source}/${id}`, entity)
	}

	sendMessage(entity: NoticeSessionRepresentationMessageRequest) {
		return this.post<NoticeSessionRepresentationMessageRequest, BaseResponse>(`${this.source}/messages`, entity)
	}

	@Retry(3)
	answer(id: string) {
		return this.update(id, new NoticeSessionRepresentation({ status: NoticeSessionRepresentationStatus.ANSWER }))
	}
}
